import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { DocumentViewerSession } from '../../core/utils/document-viewer.util';

/**
 * Dialog plein écran d'aperçu document (image / PDF / fallback mobile).
 * L'hôte conserve la {@link DocumentViewerSession} et passe {@link dialogElement}.
 */
@Component({
  selector: 'app-document-viewer-dialog',
  templateUrl: './document-viewer-dialog.component.html',
  styleUrls: ['./document-viewer-dialog.component.css'],
  imports: [FaIconComponent, TranslateModule],
})
export class DocumentViewerDialogComponent {
  @Input({ required: true }) session!: DocumentViewerSession;

  /** Préfixe i18n : `documentsAchat` ou `dossierTechnique`. */
  @Input({ required: true }) i18nPrefix!: string;

  @Output() readonly download = new EventEmitter<void>();
  @Output() readonly closeRequest = new EventEmitter<void>();
  @Output() readonly openExternally = new EventEmitter<void>();
  @Output() readonly dialogCancel = new EventEmitter<Event>();

  @ViewChild('dialog')
  private readonly dialogRef?: ElementRef<HTMLDialogElement>;

  get dialogElement(): HTMLDialogElement | undefined {
    return this.dialogRef?.nativeElement;
  }

  typeKey(type: string): string {
    return `${this.i18nPrefix}.types.${type}`;
  }

  key(suffix: string): string {
    return `${this.i18nPrefix}.${suffix}`;
  }
}
